import Region from './region'

export default class County extends Region {
}
